import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"

import List from "components/list"
import ContentfulButton from "./button"

const ContentfulList = ({ component, elRef }) => {
  const {
    bulletType,
    items,
    heading,
    backgroundColor,
    button,
    navigationAnchor,
    id,
    hideOnPageLoad,
  } = component
  const title = heading ? heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1") : null

  return (
    <ThemeProvider theme={componentThemeExtension(backgroundColor)}>
      <List
        hideOnPageLoad={hideOnPageLoad}
        dataId={id}
        id={navigationAnchor && navigationAnchor.anchorId}
        elRef={elRef}
        bulletType={bulletType}
        heading={title}
        buttonElement={button && <ContentfulButton component={button} />}
      >
        {items.map((item) => (
          <div
            key={item.id}
            dangerouslySetInnerHTML={{ __html: item.text.childMarkdownRemark.html }}
          />
        ))}
      </List>
    </ThemeProvider>
  )
}

export default ContentfulList
